import { ApiEndpoint } from "@/app/apiEndpoint";
import axios from "@/app/http/axios";
import { UserInfo } from "@/interface/UserInfo.interface";

export default class AdminExternalUserService {
  constructor() {}

  async getAllUsers() {
    const path = ApiEndpoint.AdminUserInfo.GET_ALL;
    try {
      const response = await axios.get<UserInfo[]>(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getUsersWithConditions(filter: any) {
    const path = ApiEndpoint.AdminUserInfo.SEARCH;
    try {
      const response = await axios.post<UserInfo[]>(`${path}`, filter);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async createUserInfo(value: any) {
    const path = ApiEndpoint.AdminUserInfo.CREATE;
    try {
      const response = await axios.post(`${path}`, value);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async updateUserInfo(id: number, value: any) {
    const path = ApiEndpoint.AdminUserInfo.UPDATE;
    try {
      const response = await axios.patch(
        `${path.replace("{id}", id.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async setActiveUser(id: number, value: any) {
    const path = ApiEndpoint.AdminUserInfo.UPDATE_STATUS;
    try {
      const response = await axios.patch(
        `${path.replace("{id}", id.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async resetPassword(email: string) {
    const path = ApiEndpoint.AdminUserInfo.RESET_PWD;
    try {
      const response = await axios.post(`${path}`, { email: email });
      return response;
    } catch (error: any) {
      throw error;
    }
  }
}
